import { XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

import { Button } from '../ui/button.jsx';

const CancelButton = () => {
  const location = useLocation();

  const canGoBack = location.key !== 'default';
  const href = canGoBack ? -1 : '/';

  return (
    <Link to={href}>
      <Button variant="destructive">
        <XIcon />
        Cancelar
      </Button>
    </Link>
  );
};

export default CancelButton;
